module.exports = __webpack_public_path__ + "static/media/login-banner.66bff0e1.jpg";